module.exports = __webpack_public_path__ + "img/logo_wave_writer.11ef6348.png";